import {modal} from './init-modal';

const initAppearingModal = () => {
  const appearingModal = document.querySelector('[data-appearing-modal]');
  const buttonToForm = document.querySelector('[data-appearing-modal] .appearing-modal__button');

  appearingModal && setTimeout(() => {
    // Если после таймаута уже будет открыто какое-либо модальное окно или пользователь уже будет работать с селектами, то функция не отработает
    const openSelect = document.querySelector('.select2-container--open');
    const activeModal = document.querySelector('.custom-modal.active');
    if (!activeModal && !openSelect) {
      modal.openModal(appearingModal);
    }

    buttonToForm?.addEventListener('click', () => {
      appearingModal.removeAttribute('data-modal-open');
      modal.closeModal();
      
      if (!document.querySelector('#form')) {
        window.location.href = '/#form';
      } else {
        document.querySelector('#form').scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      };
    });
  }, 180000);
};

export default initAppearingModal;
